import React, { useState, useMemo, useEffect } from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { styled } from '@material-ui/core'

import {
  PageContent,
  NoFooterContainer,
  BreadcrumbsContainer,
  CenterContainer,
} from '../containers.jsx'
import CustomBreadcrumbs from '../Breadcrumbs/CustomBreadcrumbs.jsx'
import AIEntitlementTable from './AIEntitlementTable.jsx'
import Header from '../header/Header.jsx'
import Footer from '../footer/Footer.jsx'
import AIProductList from '../../component/ai-entitlement/AIProductList.jsx'
import useAIEntitlements from '../../hooks/useAIEntitlement.js'
import useAIProducts from '../../hooks/useAIProdcutItems.js'
import { useDispatch } from 'react-redux'
import AIEntitlementDialog from './AIEntitlementDialog.jsx'
import { OPEN_DIALOG } from '../../redux/dialogReducer.jsx'
import { OPEN_ALERT } from '../../redux/alertReducer.jsx'
import { formatDate } from '../../utils'

const HorizontalContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
})

const AIEntitlements = () => {
  const {
    entitlements,
    isLoading: isEntitlementLoading,
    setNeedsFetchData,
  } = useAIEntitlements({})
  const { products, isProductsLoading } = useAIProducts({})
  const dispatch = useDispatch()
  const [selectedProduct, setSelectedProduct] = useState(null)

  useEffect(() => {
    if (products?.length > 0) {
      setSelectedProduct(products[0].productSfid)
    }
  }, [products])

  // Filter entitlements locally
  const activeEntitlements = useMemo(() => {
    if (!selectedProduct) return []
    return entitlements.filter(
      (entitlement) =>
        entitlement.assignStatus === 'Assigned' &&
        entitlement.productSfid === selectedProduct
    )
  }, [entitlements, selectedProduct])

  const historyEntitlements = useMemo(() => {
    if (!selectedProduct) return []
    return entitlements.filter(
      (entitlement) =>
        entitlement.assignStatus === 'Expired' &&
        entitlement.productSfid === selectedProduct
    )
  }, [entitlements, selectedProduct])

  const dispatchResponse = (success, response) => {
    if (success) {
      setNeedsFetchData(true)
      return dispatch({
        type: OPEN_DIALOG,
        component: AIEntitlementDialog,
        props: {
          data:
            {
              'Product Name': response?.productName,
              'Start Date': formatDate(response?.startDate),
              'Expiry Date': formatDate(response?.expiryDate),
              'Token Status': response?.assignStatus,
              Token: response?.token,
            } || {},
          copyKey: 'Token',
        },
      })
    }
    return dispatch({
      type: OPEN_ALERT,
      msg: `Error creating token for the given entitlement`,
      severity: 'error',
    })
  }

  return (
    <PageContent>
      <NoFooterContainer>
        <Header />
        <CenterContainer>
          <BreadcrumbsContainer>
            <CustomBreadcrumbs
              items={[
                { label: 'Home', path: '/' },
                { label: 'AI Entitlements', path: '/ai-entitlement' },
              ]}
            />
            <div style={{ height: 16 }} />
            <HorizontalContainer>
              <AIProductList
                setSelectedProduct={setSelectedProduct}
                products={products}
                isLoading={isProductsLoading}
                dispatchResponse={dispatchResponse}
                selectedProduct={selectedProduct}
              />
              <div style={{ width: '70vw' }}>
                <AIEntitlementTable
                  title={`Active Entitlement`}
                  entitlements={activeEntitlements}
                  isEntitlementLoading={isEntitlementLoading}
                  shallDisplayActionButton={true}
                  dispatchResponse={dispatchResponse}
                />
                <div style={{ height: 32 }} />
                <AIEntitlementTable
                  title={`History Entitlement`}
                  entitlements={historyEntitlements}
                  isEntitlementLoading={isEntitlementLoading}
                  shallDisplayActionButton={false}
                  dispatchResponse={dispatchResponse}
                />
              </div>
            </HorizontalContainer>
          </BreadcrumbsContainer>
        </CenterContainer>
      </NoFooterContainer>
      <Footer />
    </PageContent>
  )
}

export default withAuthenticationRequired(AIEntitlements)
